import { makeAutoObservable } from "mobx";

class HatsStore {
  constructor() {
    this.pagesLoaded = 1;
    this.search = "";
    this.selectedClusters = [];
    this.tab = "BROWSE";
    this.selectedRiasec = [];
    this.selectedThemes = [];
    this.selectedSentiments = [];
    this.riasecMode = "goodFor";
    this.sortBy = "a-z";
    this.viewed = new Set();
    this.onlyViewed = false;
    makeAutoObservable(this);
  }

  reloadViewed = () => {
    this.viewed = this.loadViewedFromStorage();
  };

  setSearch = (search) => {
    this.search = search;
  };

  setSelectedClusters = (selectedClusters) => {
    this.selectedClusters = selectedClusters;
  };

  setTab = (tab) => {
    this.tab = tab;
  };

  setPagesLoaded = (pages) => {
    this.pagesLoaded = pages;
  };

  setSelectedRiasec = (selectedRiasec) => {
    this.selectedRiasec = selectedRiasec;
  };

  setSelectedThemes = (selectedThemes) => {
    this.selectedThemes = selectedThemes;
  };

  setSelectedSentiments = (selectedSentiments) => {
    this.selectedSentiments = selectedSentiments;
  };

  setRiasecMode = (riasecMode) => {
    this.riasecMode = riasecMode;
  };

  setSortBy = (sortBy) => {
    this.sortBy = sortBy;
  };

  setOnlyViewed = (value) => {
    this.onlyViewed = !!value;
  };

  markHatViewed = (hatId) => {
    if (!hatId) return;
    this.reloadViewed();
    this.viewed.add(Number(hatId));
    this.saveViewedToStorage();
  };

  clearViewed = () => {
    this.viewed = new Set();
    this.saveViewedToStorage();
  };

  isHatViewed = (hatId) => {
    return this.viewed.has(Number(hatId));
  };

  // -------- Persistence helpers --------
  getStorageKey = (userId) => {
    return `VIEWED_HATS_V2_${userId}`;
  };

  loadViewedFromStorage = () => {
    const userId = localStorage.getItem("currentUserId");
    if (!userId) return new Set();
    if (typeof window === "undefined") return new Set();
    try {
      const raw = localStorage.getItem(this.getStorageKey(userId));
      const parsed = raw ? JSON.parse(raw) : [];
      return new Set(Array.isArray(parsed) ? parsed.map(Number) : []);
    } catch (e) {
      console.warn("Failed to load viewed hats from storage", e);
      return new Set();
    }
  };

  saveViewedToStorage = () => {
    const userId = localStorage.getItem("currentUserId");
    if (!userId) return;
    if (typeof window === "undefined") return;
    try {
      localStorage.setItem(
        this.getStorageKey(userId),
        JSON.stringify([...this.viewed]),
      );
    } catch (e) {
      console.warn("Failed to persist viewed hats", e);
    }
  };

  toggleTheme = (theme) => {
    // Originally allowed multiple themes to be selected, but now only one can be selected
    const themeExists = this.selectedThemes.find((t) => t.id === theme.id);
    if (themeExists) {
      this.selectedThemes = [];
    } else {
      this.selectedThemes = [theme];
    }
  };

  filterByRiasec = (type) => {
    if (this.selectedRiasec.includes(type)) {
      this.selectedRiasec = this.selectedRiasec.filter((r) => r !== type);
    } else {
      this.selectedRiasec = [...this.selectedRiasec, type];
    }
  };

  onResetFilters = () => {
    this.search = "";
    this.selectedClusters = [];
    this.selectedThemes = [];
    this.selectedRiasec = [];
    this.selectedSentiments = [];
    this.onlyViewed = false;
  };
}

const hatsStore = new HatsStore();
export default hatsStore;
